// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	//is explorer
	function msieversion() {

		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
		{
			const image_fit = document.getElementsByTagName('figure');
			for(let i = 0; i < image_fit.length; i++ ){
				const this_image = image_fit[i].getElementsByTagName('img')[0];
				const image_data = this_image.dataset.srcset;
				const image_src = this_image.getAttribute('src');
				image_fit[i].classList.add('ie-bg');
				if(image_data){
					image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
				}else{
					image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
				}
			}
		}
		else
		{
			//console.log('other browser');
		}
		return false;
	}

	msieversion();

	$(".form-module-wrapper form").addClass('animate-fade top');
	$(".text-modules-wrapper .text-modules").addClass('animate-fade top');

	$(document).ready(function () {

		if (document.getElementById('home')) {
			let VideoHome = document.getElementById('myVideo');
			let contentHome = $("#home #content");
			let videoIntro = document.getElementById('video_intro');
			let SkipVideo = document.getElementById('skip_video');
			let BtnVideo = document.getElementById('btn_video');

			VideoHome.oncanplaythrough = function() {
				VideoHome.muted = true;
				VideoHome.pause();
			}

			VideoHome.addEventListener('ended', function(e) {
				contentHome.addClass("open");
				videoIntro.classList.add("close");
			});

			SkipVideo.addEventListener('click', function(e) {
				contentHome.addClass("open");
				videoIntro.classList.add("close");
				VideoHome.pause();
			});

			BtnVideo.addEventListener('click', function(e) {
				contentHome.removeClass("open");
				videoIntro.classList.remove("close");
				VideoHome.play();
			});
		}

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let contentHome = $("#home #content");
	let videoIntro = document.getElementById('video_intro');
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');

				if (document.getElementById('home')) {
					contentHome.addClass("open");
					videoIntro.classList.add("close");
				}

			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}